import { Route, Routes } from "react-router-dom";
import RouteMetadata from "../components/RouteMetadata";
import RouteScrollManager from "../components/RouteScrollManager";
import SiteLayout from "../components/SiteLayout";
import HomePage from "../pages/HomePage";
import NotFoundPage from "../pages/NotFoundPage";
import ProjectPage from "../pages/ProjectPage";
import ResumePage from "../pages/ResumePage";

/** Defines client-side routes while synchronizing route metadata and route scroll position for the static portfolio. */
export default function App() {
  return (
    <>
      <RouteMetadata />
      <RouteScrollManager />
      <SiteLayout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/resume" element={<ResumePage />} />
          <Route path="/projects/:projectId" element={<ProjectPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </SiteLayout>
    </>
  );
}
